<app-loader *ngIf="loader"></app-loader>
<section>
  <nav class="navbar navbar-expand-lg navbar-light transparent mt-2">
    <div class="col-12 d-flex align-items-center justify-content-between">
      <a routerLink="/bot-info">
        <img src="../../../assets/img/redback.png" alt="back" /><span
          class="title_get"
          class="title_get ml-2"
          >Back</span
        ></a
      >
      <span class="font-weight-bold text-dark">Home Details</span>
      <a class="title_get" (click)="homeEdit()">EDIT</a>
    </div>
  </nav>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-12">
        <p class="font-weight-bold">Home Details</p>
        <div class="row">
          <div class="col-6">Address</div>
          <div class="col-6 d-flex justify-content-end">
            <p class="text__details" *ngIf="home_details">
              {{ home_details.address }}
            </p>
            <p class="text__details" *ngIf="!home_details.address">---</p>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-6">City</div>
          <div class="col-6 d-flex justify-content-end">
            <p class="text__details" *ngIf="home_details">
              {{ home_details.city }}
            </p>
            <p class="text__details" *ngIf="!home_details.city">---</p>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-6">Pincode</div>
          <div class="col-6 d-flex justify-content-end">
            <p class="text__details" *ngIf="home_details">
              {{ home_details.pincode }}
            </p>
            <p class="text__details" *ngIf="!home_details.pincode">---</p>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-6">Home Type</div>
          <div class="col-6 d-flex justify-content-end">
            <p class="text__details" *ngIf="home_details">
              {{ home_details.houseType }}
            </p>
            <p class="text__details" *ngIf="!home_details.houseType">---</p>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-6">WiFi</div>
          <div class="col-6 d-flex justify-content-end" *ngIf="home_details">
            <p class="text__details">{{ home_details.ssid }}</p>
            <p class="text__details" *ngIf="!home_details.ssid">---</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
